import { useQuery } from '@tanstack/react-query';
import { getStat } from './api';

export function useStat() {
  return useQuery(['stat'], getStat, {
    staleTime: 10000,
  });
}
